import React from 'react';
import {IconProps} from "../services/IconConstants";

const CalendarIcon = ({size, colour, style, className}: IconProps) => {

    return (
        <svg viewBox="0 0 24 24"
             width={size}
             height={size}
             color={colour ? colour : 'var(--text)'}
             style={style}
             className={className}
             fill={"none"}>
            <path d="M18 2V5M6 2V5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"/>
            <path
                d="M19.5 3.5H4.5C3.39543 3.5 2.5 4.39543 2.5 5.5V20C2.5 21.1046 3.39543 22 4.5 22H19.5C20.6046 22 21.5 21.1046 21.5 20V5.5C21.5 4.39543 20.6046 3.5 19.5 3.5Z"
                stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2.5 8.5H21.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"
                  stroke-linejoin="round"/>
        </svg>
    );
}

export default CalendarIcon;